enum PersistenceEventType {
  SAVING,
  ERROR,
  COMPLETE,
  FINAL,
}

export default PersistenceEventType;
